import { useState } from 'react'
import _ from 'underscore'
import PageHeader from '../../../components/PageHeader/PageHeader'
import {
  Modal,
  Header,
  Segment,
  Button,
  Grid,
  Table,
  Loader,
  Input,
} from 'semantic-ui-react'
import { toast } from 'react-toastify'
import MickeyForm from '../../../components/Forms/MickeyForm'
import AdminBusinessesRow from './AdminBusinessesRow'
import env from '../../../env'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import '@silevis/reactgrid/styles.css'
import AdminDashboardMap from '../AdminDashboard/AdminDashboardMap'
import { useSelector } from 'react-redux'
import { hasPermission } from '../../../lib/utils/utils'
import { Plus } from 'phosphor-react'

import useAxios from '../../../lib/auth/useAxios'

function AdminBusinesses(props) {
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const user = useSelector((state) => state.user.user)
  const [reload, setReload] = useState(false)
  const [openBusinessModal, setOpenBusinessModal] = useState(null)
  const [openBusinessIngestModal, setOpenBusinessIngestModal] = useState(null)

  const [activeItem, setActiveItem] = useState('list')
  const [applicationType, setApplicationType] = useState('Buyer')

  const [injestStep, setInjestStep] = useState(1)
  const [injestLoading, setInjestLoading] = useState(false)
  const [injestItems, setInjestItems] = useState([])

  const axios = useAxios()

  let headerRow = [
    'Name',
    'Type',
    'Contact Name',
    'Email',
    'Phone',
    'Salespeople',
    'Account Status',
  ]
  if (hasPermission(user, 'Delete Business')) {
    headerRow.push('Actions')
  }

  let Type = [(1, 'Buyer'), (2, 'Supplier')]

  function handleBusinessForm(status, data) {
    setReload(true)
  }

  const headerSearch = [
    {
      header: 'Name',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Business',
        query_dict: { name__isnull: false },
        filter_field_value_list: ['name'],
      },
      options_titleFields: ['name'],
      options_valueFields: ['name'],
      search_param: 'name',
    },
    {
      header: 'Type',
      type: 'dropdown',
      options: [
        { key: 1, value: 1, text: 'Buyer' },
        { key: 2, value: 2, text: 'Supplier' },
      ],
      search_param: 'type',
    },
    {
      header: 'Contact Name',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Business',
        query_dict: { contact_first_name__isnull: false },
        filter_field_value_list: ['contact_first_name', 'contact_last_name'],
      },
      options_titleFields: ['contact_first_name', 'contact_last_name'],
      options_valueFields: ['contact_first_name', 'contact_last_name'],
      search_param: 'contact_full_name',
    },
    {
      header: 'Email',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Business',
        query_dict: { contact_email__isnull: false },
        filter_field_value_list: ['contact_email'],
      },
      options_titleFields: ['contact_email'],
      options_valueFields: ['contact_email'],
      search_param: 'contact_email',
    },
    {
      header: 'Phone',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Business',
        query_dict: { contact_phone__isnull: false },
        filter_field_value_list: ['contact_phone'],
      },
      options_titleFields: ['contact_phone'],
      options_valueFields: ['contact_phone'],
      options_formate_phone_number: true,
      search_param: 'contact_phone',
    },
    {
      header: 'Salespeople',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Business',
        query_dict: { salespersons__isnull: false },
        filter_field_value_list: [
          'salespersons__first_name',
          'salespersons__last_name',
        ],
      },
      options_titleFields: [
        'salespersons__first_name',
        'salespersons__last_name',
      ],
      options_valueFields: [
        'salespersons__first_name',
        'salespersons__last_name',
      ],
      search_param: 'salespeople',
    },
    {
      header: 'Account Status',
      type: 'dropdown',
      search_param: 'status',
      options: [
        {
          key: 'Not Started',
          text: 'Not Started',
          value: 'Not Started',
        },
        { key: 'Unqualified', text: 'Unqualified', value: 'Unqualified' },
        {
          key: 'Pending Approval',
          text: 'Pending Approval',
          value: 'Pending Approval',
        },
        { key: 'Approved', text: 'Approved', value: 'Approved' },
      ],
    },
  ]
  const headerSort = [
    {
      header: 'Name',
      sort_by: 'name',
    },
    {
      header: 'Type',
      hide_sort_by: true,
    },
    {
      header: 'Contact Name',
      sort_by: 'contact_first_name',
    },
    {
      header: 'Email',
      sort_by: 'contact_email',
    },
    {
      header: 'Phone',
      sort_by: 'contact_phone',
    },
    {
      header: 'Salespeople',
      sort_by: 'salespersons__first_name',
    },
    {
      header: 'Account Status',
      hide_sort_by: true,
    },
  ]

  const urlParams = {
    light_serializer: 'true',
    tenant_aware: false,
    salesperson_id: props?.salespersonId,
  }

  async function handleInjestDocumentFile(e) {
    const file = e.target.files[0]

    // Add file size check (5MB = 5 * 1024 * 1024 bytes)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('File size must be less than 5MB')
      return
    }

    setInjestLoading(true)
    const formData = new FormData()
    formData.append('file', file)

    try {
      let res = await axios.post(`/main/injest-business-list/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Frontend-Domain': window.location.hostname,
        },
        params: {
          tenant_aware: false,
        },
        withCredentials: true,
        timeout: 120000,
      })
      setInjestLoading(false)

      if (res?.data?.success) {
        setInjestItems(res?.data?.items?.items)
        setInjestStep(2)
      } else {
        toast.error('Error uploading document, please refresh and try again.')
      }
    } catch (error) {
      console.error('Upload error:', error)
      toast.error('Error uploading document, please refresh and try again.')
    }
  }

  async function addInjestBusinesses() {
    setInjestLoading(true)
    try {
      let res = await axios.post(
        `/main/injest-business-list/finalize/`,
        {
          items: injestItems,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            tenant_aware: false,
          },
        }
      )
      setInjestLoading(false)
      if (res?.data?.success) {
        setOpenBusinessIngestModal(false)
        setReload(true)
      } else {
        toast.error('Error uploading document, please refresh and try again.')
      }
    } catch (error) {
      console.error('Upload error:', error)
      toast.error('Error uploading document, please refresh and try again.')
    }
  }

  return (
    <div className={'main-container'}>
      {!props.hideHeader && (
        <PageHeader
          icon={'address book'}
          header={'Businesses'}
          buttons={
            hasPermission(user, 'Create Business')
              ? [
                  {
                    color: 'magic',
                    icon: <Plus weight="bold" />,
                    content: 'Ingest Business List',
                    onClick: () => {
                      setOpenBusinessIngestModal(true)
                    },
                    style: {
                      '--primaryColor': tenant?.deployment_primary_color,
                      '--secondaryButtonColor':
                        env.REACT_APP_SECONDARY_BUTTON_COLOR,
                    },
                  },
                  {
                    color: 'primary',
                    icon: <Plus weight="bold" />,
                    content: 'Add business',
                    onClick: () => {
                      setOpenBusinessModal(true)
                    },
                    style: {
                      '--primaryColor': tenant?.deployment_primary_color,
                      '--secondaryButtonColor':
                        env.REACT_APP_SECONDARY_BUTTON_COLOR,
                    },
                  },
                ]
              : []
          }
        />
      )}
      {!props.hideItems && (
        <Grid>
          <Grid.Row>
            <Grid.Column width={16} style={{ paddingLeft: '25px' }}>
              <div className="exchange-table-heading">
                <div className="commodities-wrapper">
                  <Header
                    as={'h2'}
                    className={
                      activeItem === 'list'
                        ? 'commodity-header selected'
                        : 'commodity-header'
                    }
                    color={activeItem === 'list' ? 'primary' : 'black'}
                    onClick={() => setActiveItem('list')}
                    style={{
                      margin: '0 1rem 1rem 0',
                      '--primaryColor': tenant?.deployment_primary_color,
                    }}
                  >
                    Business List
                  </Header>
                  <Header
                    as={'h2'}
                    className={
                      activeItem === 'map'
                        ? 'commodity-header selected'
                        : 'commodity-header'
                    }
                    color={activeItem === 'map' ? 'primary' : 'black'}
                    onClick={() => setActiveItem('map')}
                    style={{
                      margin: '0 1rem 1rem 0',
                      '--primaryColor': tenant?.deployment_primary_color,
                    }}
                  >
                    Locations Map
                  </Header>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
      {activeItem === 'list' && (
        <Segment style={{ overflowX: 'auto' }}>
          <MickeyTable
            headerRow={headerRow}
            headerSearch={headerSearch}
            headerSort={headerSort}
            urlParams={urlParams}
            basicSegment
            showHeaderNoData={true}
            url={'/main/admin-businesses/'}
            hideFooter={false}
            reload={reload}
            setReload={setReload}
            renderBodyRow={(data, index) => {
              return (
                <AdminBusinessesRow
                  business={data}
                  setBusiness={(business) => {
                    data = business
                  }}
                  setReload={setReload}
                  reload={reload}
                  index={index}
                  key={data ? data.id : null}
                />
              )
            }}
            emptyIcon={'file'}
            emptyMessage={'Business will populate here'}
          />
        </Segment>
      )}

      {activeItem === 'map' && <AdminDashboardMap />}

      <Modal
        onClose={() => setOpenBusinessModal(false)}
        onOpen={() => setOpenBusinessModal(true)}
        open={openBusinessModal}
      >
        <Modal.Header>Add Business</Modal.Header>
        <Modal.Content>
          <Grid stackable>
            <Grid.Row style={{ marginTop: '0px' }}>
              <Grid.Column>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                  }}
                >
                  <Button.Group
                    style={{
                      borderRadius: '5px',
                    }}
                  >
                    <Button
                      color={
                        applicationType === 'Supplier' ? 'lightgrey' : 'green'
                      }
                      onClick={() => setApplicationType('Buyer')}
                    >
                      Buyer
                    </Button>
                    <Button.Or />
                    <Button
                      color={
                        applicationType === 'Supplier' ? 'orange' : 'lightgrey'
                      }
                      onClick={() => setApplicationType('Supplier')}
                    >
                      Supplier
                    </Button>
                  </Button.Group>
                </div>
                <Segment
                  className={' slide-up'}
                  style={{
                    paddingBottom: '25px',
                  }}
                >
                  <Header
                    style={{ textAlign: 'center', padding: '10px' }}
                    color={applicationType === 'Supplier' ? 'orange' : 'green'}
                  >
                    <b>{applicationType} Application</b>
                  </Header>
                  <MickeyForm
                    formName={'AdminBusinessApplicationForm'}
                    model={'Business'}
                    innerSuccessMessage={
                      "Thanks for applying! We'll get back to you shortly!"
                    }
                    buttonFloatedRight={true}
                    successMessage={
                      "Thanks for applying! We'll get back to you shortly!"
                    }
                    handleForm={handleBusinessForm}
                    failureMessage={'Error with your application.'}
                    url={'/main/p-businesses/'}
                    buttonLabel={
                      applicationType === 'Supplier'
                        ? 'Add Supplier'
                        : 'Add Buyer'
                    }
                    values={{
                      is_supplier: applicationType === 'Supplier' ? true : null,
                      is_buyer: applicationType === 'Buyer' ? true : null,
                    }}
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
      <Modal
        onClose={() => setOpenBusinessIngestModal(false)}
        onOpen={() => setOpenBusinessIngestModal(true)}
        open={openBusinessIngestModal}
      >
        <Modal.Header>Ingest Document</Modal.Header>
        <Modal.Content>
          <p>
            The system will automatically pull in information, no matter what
            format you upload in! We will display the data, allow you to change
            it, and then bulk upload! Start by uploading a file with business
            information.
          </p>
          <h5>Step 1: Upload Document</h5>
          {injestStep == 1 && injestLoading && (
            <Segment style={{ minHeight: '200px' }}>
              <Loader />
            </Segment>
          )}
          {injestStep == 1 && !injestLoading && (
            <>
              <Input
                placeholder={'Upload Document'}
                name={'document'}
                type={'file'}
                onChange={(e, d) => {
                  handleInjestDocumentFile(e, d)
                }}
              />
            </>
          )}
          <h5>Step 2: Verify Information</h5>
          {injestStep == 2 && !injestLoading && (
            <>
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Business Name</Table.HeaderCell>
                    <Table.HeaderCell>Contact Name</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Phone</Table.HeaderCell>
                    <Table.HeaderCell>Address</Table.HeaderCell>
                    <Table.HeaderCell>Buyer?</Table.HeaderCell>
                    <Table.HeaderCell>Supplier?</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {injestItems?.map((item) => {
                    return (
                      <Table.Row>
                        <Table.Cell
                          style={{ overflow: 'visible', position: 'relative' }}
                        >
                          <Input value={item.name} />
                        </Table.Cell>
                        <Table.Cell
                          style={{ overflow: 'visible', position: 'relative' }}
                        >
                          <Input value={item.first_name} />
                          <Input value={item.last_name} />
                        </Table.Cell>
                        <Table.Cell>
                          <Input value={item.phone} />
                        </Table.Cell>
                        <Table.Cell>
                          <Input value={item.address} />
                        </Table.Cell>
                        <Table.Cell>
                          <Input value={item.buyer} />
                        </Table.Cell>
                        <Table.Cell>
                          <Input value={item.supplier} />
                        </Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table>
              <Button
                color={'green'}
                style={{ float: 'right' }}
                onClick={() => {
                  addInjestBusinesses()
                }}
              >
                Add to Materials List
              </Button>
              <div style={{ clear: 'right' }}></div>
            </>
          )}
        </Modal.Content>
      </Modal>
    </div>
  )
}

export default AdminBusinesses
